module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/onesence-6-d64115c7b06c6656b5f0c2fe0a45ee2a.webp";